import { Pipe, PipeTransform } from '@angular/core';
import { isset } from '@cawita/core-front';

@Pipe({
    name: 'keyIsSet'
})
export class KeyIsSetPipe implements PipeTransform {
    constructor() { }

    transform(obj: any, key: string): boolean {
        if (!isset(obj) || !key?.length) return false;
        else return isset(obj[key]);
    }
}
